// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';

const reFix = 'newsadmin';
// 抽取的接口方法
// 获取列表
export function newsList(params) {
  return ajaxRequest({
    url: reFix + '/News',
    method: 'GET',
    params: { ...params },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

export function newsGetContent(id) {
  return ajaxRequest({
    url: reFix + '/News/content?newId=' + id,
    method: 'GET',
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 添加news
export function newsAdd(data) {
  return ajaxRequest({
    url: reFix + '/News',
    method: 'POST',
    data: { ...data },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 删除news
export function newsRemove(data) {
  return ajaxRequest({
    url: reFix + '/News',
    method: 'DELETE',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 更新news
export function newsEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/News/' + id,
    method: 'PUT',
    data: { ...data },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 设置news
export function newsChange(type, data) {
  return ajaxRequest({
    url: reFix + '/News/' + type,
    method: 'PUT',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 上传图片
export function newsUpload(data) {
  return ajaxRequest({
    url: 'upload/Images/upload',
    method: 'POST',
    data,
  });
}

//---------------------------我的消息--------------------------//
// 查看我的消息
export function getMyMsgApi(params) {
  return ajaxRequest({
    url: reFix + '/MyMsg',
    params: { ...params },
  });
}

// 给用户发送我的消息
export function sendMyMsgApi(data) {
  return ajaxRequest({
    url: reFix + '/MyMsg',
    method: 'POST',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 删除用户 我的消息
export function delMyMsgApi(myMsgId) {
  let data = 'myMsgId=' + myMsgId;
  return ajaxRequest({
    url: reFix + '/MyMsg',
    method: 'DELETE',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 修改用户我的消息
export function setMyMsgApi(data) {
  return ajaxRequest({
    url: reFix + '/MyMsg',
    method: 'PUT',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}

//---------------------------系统消息--------------------------//
// 查看系统消息
export function getSysMsgApi(params) {
  return ajaxRequest({
    url: reFix + '/SysMsg',
    params,
  });
}

// 新增系统消息
export function addSysMsgApi(data) {
  return ajaxRequest({
    url: reFix + '/SysMsg',
    method: 'POST',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 删除用户 系统消息
export function delSysMsgApi(sysMsgId) {
  let data = 'SysMsgId=' + sysMsgId;
  return ajaxRequest({
    url: reFix + '/SysMsg',
    method: 'DELETE',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 修改用户系统消息
export function setSysMsgApi(data) {
  return ajaxRequest({
    url: reFix + '/SysMsg',
    method: 'PUT',
    data,
    // headers: {'Content-type': 'application/x-www-form-urlencoded'}
  });
}

// 查看系统消息内容
export function getSysMsgContentApi(sysMsgId) {
  return ajaxRequest({
    url: reFix + '/SysMsg/content',
    params: { sysMsgId },
  });
}

// -------------------   帮助中心 ------------------
// 查看帮助中心消息
export function getHelpApi(params) {
  return ajaxRequest({
    url: reFix + '/Help',
    params,
  });
}

// 新增帮助中心消息
export function addHelpApi(data) {
  return ajaxRequest({
    url: reFix + '/Help',
    method: 'POST',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 删除用户 帮助中心消息
export function delHelpApi(HelpId) {
  let data = 'HelpId=' + HelpId;
  return ajaxRequest({
    url: reFix + '/Help',
    method: 'DELETE',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 修改用户帮助中心消息
export function setHelpApi(data) {
  return ajaxRequest({
    url: reFix + '/Help',
    method: 'PUT',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}

// 查看帮助中心消息内容
export function getHelpContentApi(helpId) {
  return ajaxRequest({
    url: reFix + '/Help/content',
    params: { helpId },
  });
}

// 新增帮助中心消息内容
export function addHelpContentApi(data) {
  return ajaxRequest({
    url: reFix + '/Help/content',
    method: 'POST',
    data,
  });
}
// 删除用户 帮助中心消息内容
export function delHelpContentApi(contentId) {
  let data = 'contentId=' + contentId;
  return ajaxRequest({
    url: reFix + '/Help/content',
    method: 'DELETE',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 修改用户帮助中心消息内容
export function setHelpContentApi(data) {
  return ajaxRequest({
    url: reFix + '/Help/content',
    method: 'PUT',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}

// -----------------------  智能回复  -------------------
// 查看智能回复
export function getChatWordApi(params) {
  return ajaxRequest({
    url: reFix + '/ChatWord',
    params,
  });
}

// 新增智能回复
export function addChatWordApi(data) {
  return ajaxRequest({
    url: reFix + '/ChatWord',
    method: 'POST',
    data,
    headers: { 'content-type': 'application/json;charset=UTF-8' },
  });
}
// 删除 智能回复
export function delChatWordApi(chatWordId) {
  let data = 'chatWordId=' + chatWordId;
  return ajaxRequest({
    url: reFix + '/ChatWord',
    method: 'DELETE',
    data,
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
  });
}
// 修改智能回复
export function setChatWordApi(data) {
  return ajaxRequest({
    url: reFix + '/ChatWord/' + data.chatWordId,
    method: 'PUT',
    data,
    headers: { 'content-type': 'application/json;charset=UTF-8' },
  });
}
